<div class="pa-shell">
  <div class="pa-dataset-bar" *ngIf="dataSets.length > 0">
    <label class="pa-dataset-label">Dataset</label>
    <select class="pa-dataset-select"
            [value]="selectedDataSetId"
            (change)="onDataSetChange($any($event.target).value)">
      <option *ngFor="let ds of dataSets" [value]="ds.id">{{ ds.name }}</option>
    </select>
  </div>

  <div class="pa-header">
    <h2>Partner Assignment</h2>

    <div class="pa-tabs">
      <button class="pa-tab"
              [class.active]="activeTab === 'records'"
              (click)="switchTab('records')">
        Record Assignment
      </button>

      <button class="pa-tab"
              [class.active]="activeTab === 'attachments'"
              (click)="switchTab('attachments')">
        Attachment Assignment
      </button>
    </div>

    <button class="btn-primary"
            *ngIf="activeTab === 'records'"
            (click)="save()"
            [disabled]="selectedPartnerIds.size === 0 || selectedRecordIds.size === 0">
      Save Changes
    </button>

    <button class="btn-primary"
            *ngIf="activeTab === 'attachments'"
            (click)="saveAttachmentAssignment()"
            [disabled]="!canSaveAttachments">
      Save Attachment Access
    </button>

  </div>

  <div class="pa-grid" *ngIf="activeTab === 'records'">

    <!-- LEFT: PARTNERS -->
    <section class="pa-panel pa-partners">
      <div class="pa-panel-title">
        Partners
        <span class="pa-selected-badge" *ngIf="selectedPartnerIds.size > 0">
          {{ selectedPartnerIds.size }} selected
        </span>
        <button class="pa-add-btn" (click)="openCreatePartner()">+ Add Partner</button>
      </div>

      <!-- CREATE PARTNER FORM -->
      <div class="pa-create-form" *ngIf="createPartnerMode">
        <input class="pa-form-input"
               type="text"
               placeholder="Code *"
               [(ngModel)]="newPartnerCode"
               maxlength="50" />
        <input class="pa-form-input"
               type="text"
               placeholder="Name *"
               [(ngModel)]="newPartnerName"
               maxlength="200" />
        <select class="pa-form-input"
                [(ngModel)]="newPartnerRefClientId">
          <option [ngValue]="null">No associated client</option>
          <option *ngFor="let c of availableClients" [value]="c.id">{{ c.displayName }}</option>
        </select>
        <div class="pa-form-actions">
          <button class="btn-primary pa-form-save"
                  (click)="submitCreatePartner()"
                  [disabled]="!newPartnerCode.trim() || !newPartnerName.trim()">
            Create
          </button>
          <button class="ghost-btn" (click)="cancelCreatePartner()">Cancel</button>
        </div>
      </div>

      <div class="pa-list-toolbar">
        <div class="pa-search">
          <input type="text"
                 placeholder="Search clients/partners..."
                 [value]="partnerSearchTerm"
                 (input)="onPartnerSearchChange($any($event.target).value)" />
          <button type="button"
                  class="ghost-btn search-clear"
                  [disabled]="!partnerSearchTerm"
                  (click)="clearPartnerSearch()">
            Clear
          </button>
        </div>
        <label *ngIf="partnerTotalCount > 0">
          Show
          <select [value]="partnerPageSize"
                  (change)="onPartnerPageSizeChange(+$any($event.target).value)">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="25">25</option>
          </select>
          per page
        </label>
      </div>

      <div class="pa-list" *ngIf="partners.length > 0">
        <div class="pa-row"
             *ngFor="let p of partners"
             (click)="togglePartner(p)"
             [class.selected]="isPartnerSelected(p.id)"
             [class.focused]="isActivePartner(p.id)">

          <input type="radio"
                 name="partner"
                 [checked]="isActivePartner(p.id)"
                 (click)="$event.stopPropagation()"
                 (change)="togglePartner(p)" />

          <div class="pa-row-main">
            <div class="pa-title">{{ p.name }}</div>
            <div class="pa-subtitle" *ngIf="p.refClientName"><span class="pa-subtitle-label">Client:</span> {{ p.refClientName }}</div>
          </div>

          <button class="pa-row-menu-btn"
                  (click)="openPartnerMenu(p, $event)"
                  title="Manage Users · Assign Client · Delete">⋮</button>
        </div>
      </div>

      <div class="empty" *ngIf="partnerTotalCount === 0">
        No partners found.
      </div>

      <div class="pa-pager" *ngIf="partnerTotalCount > 0">
        <button class="ghost-btn"
                (click)="goToPartnerPage(partnerPage - 1)"
                [disabled]="partnerPage <= 1">
          ‹ Prev
        </button>
        <span class="pa-pager-info">
          {{ partnerRangeLabel }}
          · Page {{ partnerPage }} / {{ partnerTotalPages }}
        </span>
        <button class="ghost-btn"
                (click)="goToPartnerPage(partnerPage + 1)"
                [disabled]="partnerPage >= partnerTotalPages">
          Next ›
        </button>
      </div>

      <!-- ASSIGN CLIENT PANEL -->
      <div #assignPanel class="pa-users-panel" *ngIf="assigningClientPartner">
        <div class="pa-users-header">
          <span>Assign Client — <strong>{{ assigningClientPartner.name }}</strong></span>
          <button class="pa-users-close" (click)="closeAssignClient()">✕</button>
        </div>
        <select class="pa-form-input" [(ngModel)]="assignClientRefId">
          <option [ngValue]="null">No associated client</option>
          <option *ngFor="let c of availableClients" [value]="c.id">{{ c.displayName }}</option>
        </select>
        <div class="pa-form-actions">
          <button class="btn-primary" (click)="submitAssignClient()">Save</button>
          <button class="ghost-btn" (click)="closeAssignClient()">Cancel</button>
        </div>
      </div>

      <!-- USER MANAGEMENT PANEL -->
      <div #usersPanel class="pa-users-panel" *ngIf="managingUsersPartner">
        <div class="pa-users-header">
          <span>Users — <strong>{{ managingUsersPartner.name }}</strong></span>
          <button class="pa-users-close" (click)="closeManageUsers()">✕</button>
        </div>

        <div class="pa-user-list">
          <div class="pa-user-row" *ngFor="let u of partnerUsers">
            <div class="pa-user-info">
              <div class="pa-user-name">{{ u.name }}</div>
              <div class="pa-user-email">{{ u.email }}</div>
            </div>
            <button class="btn-revoke" (click)="removeUser(u.id)">Remove</button>
          </div>
          <div class="empty" *ngIf="partnerUsers.length === 0">No users in this partner.</div>
        </div>

        <div class="pa-add-user" *ngIf="addableUsers.length > 0">
          <select class="pa-form-input" [(ngModel)]="userToAdd">
            <option value="">Select user to add...</option>
            <option *ngFor="let u of addableUsers" [value]="u.id">
              {{ u.name }} ({{ u.email }})
            </option>
          </select>
          <button class="btn-primary"
                  (click)="addUser()"
                  [disabled]="!userToAdd">
            Add
          </button>
        </div>
      </div>
    </section>

    <!-- CONTEXT MENU -->
    <div class="pa-context-menu"
         *ngIf="menuPartner"
         [style.top.px]="menuY"
         [style.left.px]="menuX"
         (click)="$event.stopPropagation()">
      <button class="pa-context-item" (click)="openManageUsers(menuPartner!)">
        Manage Users
      </button>
      <button class="pa-context-item" (click)="openAssignClient(menuPartner!)">
        Assign Client
      </button>
      <button class="pa-context-item pa-context-danger" (click)="deletePartner(menuPartner!)">
        Delete
      </button>
    </div>

    <!-- MIDDLE: RECORDS -->
    <section class="pa-panel pa-records">
      <div class="pa-panel-title">
        Records
        <span class="pa-selected-badge" *ngIf="selectedRecordIds.size > 0">
          {{ selectedRecordIds.size }} selected
        </span>
        <span class="pa-panel-hint" *ngIf="activePartnerId">
          — editing <strong>{{ activePartnerName }}</strong>
        </span>
      </div>
      <div class="pa-list-toolbar">

        <div class="pa-search">
          <input type="text"
                 placeholder="Search wells, API, field..."
                 [value]="searchTerm"
                 (input)="onSearchChange($any($event.target).value)" />

          <button type="button"
                  class="ghost-btn search-clear"
                  [disabled]="!searchTerm"
                  (click)="clearSearch()">
            Clear
          </button>
        </div>

        <label *ngIf="totalCount > 0">
          Show
          <select [value]="pageSize"
                  (change)="onPageSizeChange(+$any($event.target).value)">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="25">25</option>
          </select>
          per page
        </label>

      </div>

      <div class="pa-loading" *ngIf="loading">
        Loading records…
      </div>

      <div class="pa-list" *ngIf="!loading && records.length > 0">
        <div class="pa-row"
             *ngFor="let r of records"
             (click)="toggleRecord(r.id)"
             [class.selected]="isRecordSelected(r.id)">

          <input type="checkbox"
                 [checked]="isRecordSelected(r.id)"
                 (click)="$event.stopPropagation()"
                 (change)="toggleRecord(r.id)" />

          <div class="pa-row-main well-card">

            <div class="well-name">
              {{ getWellName(r) }}
            </div>

            <div class="well-meta">
              <span class="meta-label">API</span>
              <span class="meta-value">{{ getApi(r) }}</span>
            </div>

            <div class="well-meta">
              <span class="meta-label">Field</span>
              <span class="meta-value">{{ getFieldName(r) }}</span>
            </div>

            <div class="well-dates"
                 *ngIf="r.fields['spud_date'] || r.fields['rig_release_date']">

              <span *ngIf="r.fields['spud_date']">
                Spud {{ getDate(r.fields['spud_date']) }}
              </span>

              <span *ngIf="r.fields['rig_release_date']">
                • Rig Release {{ getDate(r.fields['rig_release_date']) }}
              </span>

            </div>

          </div>
        </div>
      </div>

      <div class="empty" *ngIf="!loading && records.length === 0">
        No records found.
      </div>

      <div class="pa-pager" *ngIf="!loading && totalCount > 0">
        <button class="ghost-btn"
                (click)="goToPage(page - 1)"
                [disabled]="page <= 1">
          ‹ Prev
        </button>

        <span class="pa-pager-info">
          {{ rangeLabel }}
          · Page {{ page }} / {{ totalPages }}
        </span>

        <button class="ghost-btn"
                (click)="goToPage(page + 1)"
                [disabled]="page >= totalPages">
          Next ›
        </button>
      </div>
    </section>

    <!-- RIGHT: ASSIGNMENT SUMMARY -->
    <section class="pa-panel pa-matrix">
      <div class="pa-panel-title">Records Assigned Summary</div>

      <div class="pa-matrix-scroll">

        <div class="pa-matrix-empty" *ngIf="selectedPartnerMatrix.length === 0">
          Select a partner to view access.
        </div>

        <div *ngFor="let p of selectedPartnerMatrix; trackBy: trackByPartnerId" class="pa-matrix-entry">

          <!-- Partner header -->
          <div class="pa-matrix-partner-header">
            <span class="pa-matrix-badge">Partner</span>
            <span class="pa-matrix-partner-name">{{ p.partnerName }}</span>
            <span class="pa-matrix-record-count">
              {{ summaryTotalCount }} record{{ summaryTotalCount !== 1 ? 's' : '' }}
            </span>
          </div>

          <!-- Search + bulk revoke toolbar -->
          <div class="pa-list-toolbar" *ngIf="summaryAllRecords.length > 0">
            <div class="pa-search">
              <input type="text"
                     placeholder="Search assigned records..."
                     [value]="summarySearchTerm"
                     (input)="onSummarySearch($any($event.target).value)" />
              <button type="button"
                      class="ghost-btn search-clear"
                      [disabled]="!summarySearchTerm"
                      (click)="clearSummarySearch()">
                Clear
              </button>
            </div>
            <button class="btn-revoke"
                    *ngIf="revokeSelectedIds.size > 0"
                    (click)="revokeSelected()">
              Revoke {{ revokeSelectedIds.size }} selected
            </button>
          </div>

          <!-- Records listed vertically -->
          <div class="pa-matrix-record-row"
               *ngFor="let r of summaryPagedRecords"
               [class.selected]="isRevokeSelected(r.id)">

            <input type="checkbox"
                   [checked]="isRevokeSelected(r.id)"
                   (click)="$event.stopPropagation()"
                   (change)="toggleRevokeSelect(r.id)" />

 
            <span class="pa-matrix-record-name">
              {{ getWellName(r) }}
            </span>

            <button class="btn-revoke"
                    (click)="revokeRecordAccess(r.id); $event.stopPropagation()">
              Revoke
            </button>

          </div>

          <!-- Pagination -->
          <div class="pa-pager" *ngIf="summaryTotalPages > 1">
            <button class="ghost-btn"
                    (click)="goToSummaryPage(summaryPage - 1)"
                    [disabled]="summaryPage <= 1">
              ‹ Prev
            </button>
            <span class="pa-pager-info">
              {{ summaryRangeLabel }}
              · Page {{ summaryPage }} / {{ summaryTotalPages }}
            </span>
            <button class="ghost-btn"
                    (click)="goToSummaryPage(summaryPage + 1)"
                    [disabled]="summaryPage >= summaryTotalPages">
              Next ›
            </button>
          </div>

        </div>

      </div>
    </section>
  </div>

  <!-- ===================== TAB 2 ===================== -->
  <div class="pa-grid" *ngIf="activeTab === 'attachments'">

    <!-- LEFT: PARTNERS -->
    <section class="pa-panel pa-partners">
      <div class="pa-panel-title">
        Partners
        <span class="pa-selected-badge" *ngIf="selectedPartnerIds.size > 0">
          {{ selectedPartnerIds.size }} selected
        </span>
      </div>

      <div class="pa-list-toolbar">
        <div class="pa-search">
          <input type="text"
                 placeholder="Search partners..."
                 [value]="partnerSearchTerm"
                 (input)="onPartnerSearchChange($any($event.target).value)" />

          <button type="button"
                  class="ghost-btn search-clear"
                  [disabled]="!partnerSearchTerm"
                  (click)="clearPartnerSearch()">
            Clear
          </button>
        </div>

        <label *ngIf="partnerTotalCount > 0">
          Show
          <select [value]="partnerPageSize"
                  (change)="onPartnerPageSizeChange(+$any($event.target).value)">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="25">25</option>
          </select>
          per page
        </label>
      </div>

      <div class="pa-list" *ngIf="partners.length > 0">

        <div class="pa-row"
             *ngFor="let p of partners"
             (click)="togglePartner(p)"
             [class.selected]="isPartnerSelected(p.id)">

          <input type="radio"
                 name="partner"
                 [checked]="isActivePartner(p.id)"
                 (click)="$event.stopPropagation()"
                 (change)="togglePartner(p)" />

          <div class="pa-row-main">
            <div class="pa-title">{{ p.name }}</div>
          </div>
        </div>
      </div>

      <div class="empty" *ngIf="partnerTotalCount === 0">
        No partners found.
      </div>

      <div class="pa-pager" *ngIf="partnerTotalCount > 0">
        <button class="ghost-btn"
                (click)="goToPartnerPage(partnerPage - 1)"
                [disabled]="partnerPage <= 1">
          ‹ Prev
        </button>

        <span class="pa-pager-info">
          {{ partnerRangeLabel }}
          · Page {{ partnerPage }} / {{ partnerTotalPages }}
        </span>

        <button class="ghost-btn"
                (click)="goToPartnerPage(partnerPage + 1)"
                [disabled]="partnerPage >= partnerTotalPages">
          Next ›
        </button>
      </div>
    </section>

    <!-- MIDDLE: RECORDS FOR SELECTED PARTNER -->
    <section class="pa-panel pa-folders">

      <div class="pa-panel-title">
        Records
        <span class="pa-panel-hint" *ngIf="activePartnerId">
          — {{ activePartnerName }}
        </span>
      </div>

      <div class="empty" *ngIf="!activePartnerId">
        Select a partner to view records.
      </div>

      <div class="empty" *ngIf="activePartnerId && activePartnerRecordIds.length === 0">
        No records assigned to this partner.
      </div>

      <div class="pa-list-toolbar" *ngIf="activePartnerRecordIds.length > 0">
        <div class="pa-search">
          <input type="text"
                 placeholder="Search records..."
                 [value]="attachmentRecordSearchTerm"
                 (input)="onAttachmentRecordSearch($any($event.target).value)" />
          <button type="button"
                  class="ghost-btn search-clear"
                  [disabled]="!attachmentRecordSearchTerm"
                  (click)="clearAttachmentRecordSearch()">
            Clear
          </button>
        </div>
      </div>

      <div class="pa-list" *ngIf="pagedAttachmentRecords.length > 0">
        <div class="pa-row"
             *ngFor="let record of pagedAttachmentRecords"
             (click)="selectRecordForAttachment(record.id)"
             [class.selected]="isSelectedForAttachment(record.id)">

          <div class="pa-row-main">
            <div class="pa-title">
              {{ getWellName(record) }}
            </div>
          </div>

        </div>
      </div>

      <div class="empty"
           *ngIf="activePartnerId && activePartnerRecordIds.length > 0 && pagedAttachmentRecords.length === 0">
        No records match your search.
      </div>

      <div class="pa-pager" *ngIf="attachmentRecordTotalPages > 1">
        <button class="ghost-btn"
                (click)="goToAttachmentRecordPage(attachmentRecordPage - 1)"
                [disabled]="attachmentRecordPage <= 1">
          ‹ Prev
        </button>
        <span class="pa-pager-info">
          {{ attachmentRecordRangeLabel }}
          · Page {{ attachmentRecordPage }} / {{ attachmentRecordTotalPages }}
        </span>
        <button class="ghost-btn"
                (click)="goToAttachmentRecordPage(attachmentRecordPage + 1)"
                [disabled]="attachmentRecordPage >= attachmentRecordTotalPages">
          Next ›
        </button>
      </div>

    </section>

    <!-- RIGHT: FOLDER TREE WITH PERMISSION CHECKBOXES -->
    <section class="pa-panel pa-folder-perms">

      <div class="pa-panel-title">
        Attachments
        <span class="pa-selected-badge"
              *ngIf="selectedHierarchyIds.size + selectedAttachmentIds.size > 0">
          {{ selectedHierarchyIds.size + selectedAttachmentIds.size }} granted
        </span>
      </div>

      <div class="empty" *ngIf="!selectedRecordId">
        Select a record to view its folders.
      </div>

      <div class="empty" *ngIf="selectedRecordId && folderTree.length === 0">
        No folders found for this record.
      </div>

      <div class="pa-folder-tree" *ngIf="selectedRecordId && folderTree.length > 0">

        <ng-template #folderNode let-folder="folder" let-depth="depth">
          <div class="pa-folder-node"
               [class.pa-folder-empty]="isFolderEmpty(folder)"
               [style.padding-left.px]="depth * 16">

            <div class="pa-folder-row"
                 [class.selected]="isHierarchySelected(folder.id)"
                 (click)="toggleHierarchy(folder.id)">

              <button class="pa-folder-chevron"
                      *ngIf="!isFolderEmpty(folder)"
                      (click)="toggleFolderCollapse(folder.id, $event)"
                      [title]="isFolderCollapsed(folder.id) ? 'Expand' : 'Collapse'">
                {{ isFolderCollapsed(folder.id) ? '▶' : '▼' }}
              </button>
              <span class="pa-folder-chevron-spacer" *ngIf="isFolderEmpty(folder)"></span>

              <input type="checkbox"
                     [checked]="isHierarchySelected(folder.id)"
                     (click)="$event.stopPropagation()"
                     (change)="toggleHierarchy(folder.id)" />
              <span class="pa-folder-icon">📁</span>
              <span class="pa-folder-name">{{ folder.folderName }}</span>
              <span class="pa-folder-count" *ngIf="!isFolderEmpty(folder)">
                <ng-container *ngIf="folderFileCount.get(folder.id.toLowerCase()) as count">
                  {{ count }} file{{ count !== 1 ? 's' : '' }}
                </ng-container>
                <ng-container *ngIf="!folderFileCount.get(folder.id.toLowerCase())">
                  0 files
                </ng-container>
              </span>
              <span class="pa-folder-empty-label" *ngIf="isFolderEmpty(folder)">empty</span>
            </div>

            <ng-container *ngIf="!isFolderCollapsed(folder.id)">

              <div class="pa-file-list" *ngIf="(folderFileMap.get(folder.id.toLowerCase()) ?? []).length > 0">
                <div class="pa-file-row"
                     *ngFor="let file of (folderFileMap.get(folder.id.toLowerCase()) ?? [])"
                     [class.selected]="isAttachmentSelected(file.id)"
                     (click)="toggleAttachmentFile(file.id)"
                     [title]="file.fileName">
                  <input type="checkbox"
                         [checked]="isAttachmentSelected(file.id)"
                         (click)="$event.stopPropagation()"
                         (change)="toggleAttachmentFile(file.id)" />
                  <span class="pa-file-icon">📄</span>
                  <span class="pa-file-name">{{ file.fileName }}</span>
                  <span class="pa-file-meta" *ngIf="file.effectiveDate">
                    {{ file.effectiveDate | date:'shortDate' }}
                  </span>
                </div>
              </div>

              <ng-container *ngFor="let child of folder.children">
                <ng-container *ngTemplateOutlet="folderNode; context: { folder: child, depth: depth + 1 }">
                </ng-container>
              </ng-container>

            </ng-container>

          </div>
        </ng-template>

        <ng-container *ngFor="let folder of folderTree">
          <ng-container *ngTemplateOutlet="folderNode; context: { folder: folder, depth: 0 }">
          </ng-container>
        </ng-container>

      </div>

    </section>

  </div>
</div>
